import { createFileRoute } from "@tanstack/react-router";
import { CaseStudyLedgerView } from "@/components/archive/CaseStudyLedgerView";

export const Route = createFileRoute("/_authenticated/dashboard/case-studies/")({
  head: () => ({ meta: [{ title: "Case Studies | Member Desk" }, { name: "robots", content: "noindex" }] }),
  component: () => <CaseStudyLedgerView member />,
});
